// On advertising.amazon.com there is a "languageOfPreference" cookie set
export const COOKIE_NAME_AMAZON_ADVERTISING_DOMAIN = 'languageOfPreference'

export const LOCALIZATION_CONSOLIDATION: Map<string, string> = new Map([
  ['en-ca', 'en-us'],
  ['en-gb', 'en-us'],
  ['es-mx', 'es-es'],
  ['fr-ca', 'fr-fr'],
])

export const getCookie = (cookieName: string): string => {
  const cookiesArray = document.cookie.split(';')
  const cookies = new Map(
    cookiesArray.map(str => {
      const cookie = str.trim().split('=')
      return [cookie[0], cookie[1]]
    }),
  )

  return cookies.get(cookieName) ?? ''
}

const supportedLangCode: Set<string> = new Set([
  'ar-ae',
  'de-de',
  'en-us',
  'es-es',
  'fr-fr',
  'it-it',
  'ja-jp',
  'ko-kr',
  'nl-nl',
  'pl-pl',
  'pt-br',
  'sv-se',
  'tr-tr',
  'zh-cn',
])

const isLocale = (locale: string): boolean => {
  return supportedLangCode.has(locale)
}

const getLanguage = (url: string): string => {
  const subPaths = url.split('/')
  const locale = subPaths.filter(path => isLocale(path))

  return locale[0]
}
const getLocaleFromURL = (): string => {
  const urlLocale = getLanguage(document.location.href)
  if (!!urlLocale) return urlLocale.replace('-', '_')
  else return 'en_us'
}

export const getLanguageOfPreference = (): string => {
  const languageOfPreference = getCookie(COOKIE_NAME_AMAZON_ADVERTISING_DOMAIN)
  const consolidatedLopCookie = LOCALIZATION_CONSOLIDATION.get(languageOfPreference)
  if (consolidatedLopCookie) {
    return consolidatedLopCookie.replace('-', '_')
  }
  return languageOfPreference === '' ? getLocaleFromURL() : languageOfPreference.replace('-', '_')
}
